export default __webpack_public_path__ + "static/media/BM_RenderCamera_07_BathroomA+Interior+Light_Scheme+Bathroom.778b77ba.jpg";